import * as FwDatas from "../../FwDatas.ts";

//if we do $.extend({},aTruePrototype) it does not work, so we build a fake proto
const ISharableByMemberProto = {
  isShared(){
    return this.sharedToAll || (this.sharedMemberIds && this.sharedMemberIds.length>1);
  },
  sharedMembers(){
    var 
      result = [],
      members = FwDatas.getFamily().members,
      sharedIds = this.sharedMemberIds||[],
      sharedToAll = this.sharedToAll;
    members.forEach(function(member){
      if(member.isloggedaccount){
        return;
      }
      function MemberSharedView(shared){
        this.shared=shared;
      }
      MemberSharedView.prototype=member;
      result.push(new MemberSharedView(sharedToAll || sharedIds.indexOf(member.accountId)!==-1));
    });
    return result;  
  }
}

export default ISharableByMemberProto;
